/**
 * The ONE list of file types the importer accepts, shared by the Import
 * dialog and the sidebar file-drop (which imports directly, no modal —
 * owner call 24.08.2026). Two copies of this list drifted apart is exactly
 * the bug class this module exists to prevent.
 */
export const ACCEPTED_EXTENSIONS = ['.json', '.yaml', '.yml', '.har', '.bru'];

export function isAcceptedFile(file) {
  if (!file) return false;
  const name = String(file.name || '').toLowerCase();
  return ACCEPTED_EXTENSIONS.some((ext) => name.endsWith(ext));
}

export function isHarFile(file) {
  if (!file) return false;
  return String(file.name || '').toLowerCase().endsWith('.har');
}
